const choices = {
    yes: 'En raison d\'un retrait anticipé ',
    no: 'Evolution du marché',
};

export default choices;
